import React from "react";

const TimerIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    fill="none"
    {...props}
    viewBox="0 0 20 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.8748 5.63153L16.364 7.18657M16.364 7.18657C14.6761 5.44936 12.3869 4.47341 10 4.47341C7.61305 4.47341 5.32387 5.44936 3.63604 7.18657C1.94821 8.92377 1 11.2799 1 13.7367C1 16.1935 1.94821 18.5496 3.63604 20.2868C5.32387 22.024 7.61305 23 10 23C12.3869 23 14.6761 22.024 16.364 20.2868C18.0518 18.5496 19 16.1935 19 13.7367C19 11.2799 18.0518 8.92377 16.364 7.18657ZM10 9.10518V13.7367M6.62509 1H13.3749"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TimerIcon;
